/**
 * @license
 * Copyright© Celligence International, LLC - 2023
 * This software program is protected by copyright laws and is the property of
 * Celligence International, LLC (Celligence). Any unauthorized reproduction,
 * distribution, modification, or public display of this program, without the
 * explicit permission of Celligence is strictly prohibited. If you have gained
 * access to this program without the expressed approval of Celligence report
 * the incident to legal@celligence.com.
*/
import React from 'react';
import { Container } from 'react-bootstrap';
import './increasingloanlimit.css';
import parse from 'html-react-parser';

function IncreasingLoanLimit({ data }) {
  // If no data is provided, don't render the component
  if (!data) return null;
  
  const {
    title,
    description,
    methods,
    mainColor,
    backgroundColor,
    textColor,
    titleColor,
    borderColor
  } = data;
  
  // Safe parse function to handle undefined or null content
  const safeParse = (content) => {
    if (content === undefined || content === null) return '';
    return parse(content.toString());
  };

  // Create dynamic styles based on the JSON data
  const sectionStyle = backgroundColor ? {
    backgroundColor: backgroundColor,
    color: textColor || 'white'
  } : {};

  const titleStyle = titleColor ? {
    color: titleColor
  } : {};

  return (
    <div className="increasing-heloc-limit-section" style={sectionStyle}>
      <Container>
        <div className="heloc-increase-header">
          {title && <h2 className="heloc-increase-title" style={titleStyle}>{safeParse(title)}</h2>}
          {description && <p className="heloc-increase-description">{safeParse(description)}</p>}
        </div>
        
        <div className="heloc-methods-container">
          {methods && methods.map((method, index) => {
            // Get method-specific styles or fall back to global styles
            const methodBgColor = method.backgroundColor || mainColor;
            const methodBorderColor = method.borderColor || borderColor;
            
            const methodTitleContainerStyle = methodBgColor ? {
              backgroundColor: methodBgColor
            } : {};
            
            const methodBoxStyle = methodBorderColor ? {
              border: `1px solid ${methodBorderColor}`
            } : {};
            
            return (
              <div key={index} className="heloc-method-row mb-4">
                <div className="heloc-method-box" style={methodBoxStyle}>
                  <div className="method-title-container" style={methodTitleContainerStyle}>
                    <h3 className="method-title">{safeParse(method.title)}</h3>
                  </div>
                  <div className="method-details">
                    <ul className="method-points">
                      {method.points && method.points.map((point, pointIndex) => (
                        <li key={pointIndex} className="method-point-item">
                          {safeParse(point.text)}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </Container>
    </div>
  );
}

export default IncreasingLoanLimit;